import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Collapse, Loading } from 'tdesign-react';
import CodeMirrorLight from '@/components/CodeMirrorLight';
import ComponentInfo from './ComponentInfo';

const { Panel: CollapsePanel } = Collapse;

function OtherConfig({ advancedSteps, loading }) {
  return (
    <Root>
      <Loading loading={loading}>
        <Collapse borderless defaultExpandAll expandIconPlacement='right'>
          {advancedSteps.map((step) => (
            <CollapsePanel value={step.id} key={step.id} header={step.prettyText}>
              {step.stencilType === 0 && (
                <Script className='narrow-scrollbar'>
                  <CodeMirrorLight value={step?.scriptContent} readOnly />
                </Script>
              )}
              {step.stencilType === 1 && <ComponentInfo currentAdvancedStep={step} />}
            </CollapsePanel>
          ))}
        </Collapse>
      </Loading>
    </Root>
  );
}

export default connect((state) => ({
  advancedSteps: state.execFlow.advancedSteps,
  loading: state.execFlow.loading,
}))(OtherConfig);

const Root = styled.div`
  flex: 1;
  min-width: 0;
  padding: 10px 20px 20px;
  .t-collapse-panel__header {
    height: 40px;
    box-sizing: border-box;
    font-weight: normal;
    color: var(--td-text-color-secondary);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
    background: #f7f8fa;
    margin-top: 8px;
  }
  .t-collapse-panel__content {
    padding: 0;
  }
`;

const Script = styled.div`
  margin-top: 6px;

  width: 100%;
  .cm-editor {
    height: 300px;
  }
`;
